import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { changeFormField } from 'apps/auth/actions/formAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { INCREASE_LIMITS_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { GT_LEVEL } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { MULTIPLE_AMOUNT_ISSUE } from 'apps/auth/constants/Constants';
import { RECALCULATE } from 'apps/auth/constants/ExtraNames';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import update from 'apps/auth/helpers/Immutability';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useApp, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';

export const GAErrorDetailsPopup = (props) => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const { value } = props.amountField;
    const { leftLimitAmount, increaseLimit, profile, canMakeDraftTransaction } = useExtra();
    const { sendLimit, changeAmount, calcCommissionIncreaseLimit } = usePageMessages();
    const expectedGTLevel = profile?.amlLimit?.currentLimit + 1;
    const isShowButtonNormalFlow = increaseLimit && !canMakeDraftTransaction && !props.isBonus && props.amountField?.error?.code !== MULTIPLE_AMOUNT_ISSUE;
    const getErrorText = () => {
        return getErrorTextConsideringBalance();
    };

    const getErrorTextConsideringBalance = () => {
        if (props.maxAmount && value > props.maxAmount) {
            return resolveArguments(sendLimit, [`${getLocalizedRawAmount(lang, country, props.maxAmount)} ${props.currencyCodeFrom}`]);
        } else if (props.isFrom && value > props.balance) {
            return resolveArguments(props.maxPocketError, [
                props.currencyCodeFrom,
                getLocalizedRawAmount(lang, country, value - props.balance) + ' ' + props.currencyCodeFrom,
            ]);
        } else if (props.multiple && value % props.multiple !== 0) {
            return resolveArguments(props.multipleError, getLocalizedRawAmount(lang, country, props.multiple));
        }
    };

    const defaultDecreaseAmountButtonClick = () => {
        let min = props.maxAmount;
        if (!!leftLimitAmount) {
            min = Math.min(leftLimitAmount, props.maxAmount);
        } else if (!!props.balance && !!props.maxAmount) {
            min = Math.min(props.balance, props.maxAmount);
        } else if (props.balance) {
            min = props.balance;
        }
        const newField = update(props.amountField, {
            $auto: {
                value: { $set: min },
                isError: { $set: false },
                error: {
                    $auto: {
                        code: { $set: '' },
                        body: { $set: '' },
                    },
                },
            },
        });
        props.changeFormField(props.formName, newField).then(() => props.updateExtraByName(RECALCULATE, true));
    };

    return (
        <SimplePopup text={<DangerouslyHtml dangerouslyHtml={getErrorText()} />} popupRef={props.popupRef}>
            {isShowButtonNormalFlow && (
                <PopupButton
                    iconName={'arrow-up'}
                    text={calcCommissionIncreaseLimit}
                    href={props.gaIncreaseLvlLink}
                    onClick={() => {
                        if (expectedGTLevel) {
                            amplitude.getInstance().logEvent(INCREASE_LIMITS_SHOWN, { [GT_LEVEL]: expectedGTLevel });
                        }
                    }}
                />
            )}
            <PopupButton
                dataTestId="process-link"
                iconName={'retry'}
                text={changeAmount}
                onClick={(e) => {
                    e.preventDefault();
                    if (props.decreaseAmountButtonClick) {
                        props.decreaseAmountButtonClick();
                    } else {
                        defaultDecreaseAmountButtonClick();
                    }
                    props.popupRef.current?.close();
                }}
            />
        </SimplePopup>
    );
};

GAErrorDetailsPopup.propTypes = {
    isBonus: PropTypes.bool,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

const mapStateToProps = (state) => {
    return {
        balance: state.extra?.pocket?.balance,
        gaIncreaseLvlLink: state.extra?.aml_ga_increase_level_link,
        maxPocketError: state.messages.jsMessages['site.js.validation.not.enough.money.error'],
        multipleError: state.messages.jsMessages['site.js.validation.multiple.error'],
    };
};

export default connect(mapStateToProps, { changeFormField, updateExtraByName })(GAErrorDetailsPopup);
